export const ADJUST_NOTE_REQUIRED_MESSAGE = 'Add a note when the reason is Other.';
//# sourceMappingURL=adjust-note-required-message.js.map